import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import TcNav from "./TcNav";
import "../../styles/tcDash.css";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
export default function Case() {
  const [cases, setCases] = useState([]);
  const [columnName, setColumnName] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    getCases();
  }, []);

  const getCases = async () => {
    try {
      const response = await fetch("http://localhost:8000/case", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.warn(data);
      setCases(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = async () => {
    // Validate inputs and perform the search
    if (columnName && searchInput) {
      try {
        const response = await fetch(
          `http://localhost:8000/case/search?columnName=${columnName}&searchInput=${searchInput}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        console.log("Search result:", data);
        // Update the cases state with the search result
        setCases(data);
      } catch (error) {
        console.error("Error during search:", error);
      }
    } else if (!searchInput) {
      getCases();
    }
  };

  const deleteCase = async (id) => {
    const authString = localStorage.getItem("user");
    const auth = authString ? JSON.parse(authString) : [];
    console.warn(auth);
    if (auth[0].userType === "super") {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this case?"
      );

      if (isConfirmed) {
        try {
          let result = await fetch(`http://localhost:8000/case/${id}`, {
            method: "Delete",
          });
          result = await result.json();
          if (result) {
            toast.success("Case Deleted", {
              position: "top-left",
              autoClose: 2000,
              theme: "dark",
            });
            getCases();
          }
        } catch (error) {
          console.error("Error during fetch operation:", error);
        }
      }
    } else {
      toast.error("You are not authorised to perform the action!", {
        position: "top-left",
        autoClose: 2000,
        theme: "dark",
      });
    }
  };
  return (
    <div>
      <header>
        <TcNav />
      </header>
      <main>
        <div className="container mt-4 mb-4 d-flex  flex-column justify-content-center align-items-center">
          <div class=" input-group .bg-light-subtle w-50 searches">
            <input
              type="text"
              className="form-control"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search Cases"
            />
            <select
              value={columnName}
              onChange={(e) => setColumnName(e.target.value)}
              className="btn btn-outline-light"
            >
              <option selected>Select</option>
              <option value="caseID">Case ID</option>
              <option value="licenseNo">License No</option>
              <option value="location">Location</option>
              <option value="status">Status</option>

              <option value="request">Request</option>
              <option value="date">Date</option>
            </select>
            <button className="btn btn-outline-light" onClick={handleSearch}>
              Search
            </button>
          </div>
          <div>
            <h3 className="mt-4 mb-4 text-white text-center">Case List</h3>
            <div className="container">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Case ID</th>
                    <th>Violation Type</th>
                    <th>Fine to pay</th>
                    <th>Case Status</th>
                    <th>Request</th>
                    <th>Station Under</th>
                    <th>Case Added Date</th>
                    <th>License No</th>
                    
                    <th>Perform Operations</th>
                  </tr>
                </thead>
                <tbody>
                  {cases.map((caseItem) => (
                    <tr key={caseItem.id}>
                      <td>{caseItem.caseID}</td>
                      <td>{caseItem.violated}</td>
                      <td>{caseItem.fines}</td>
                      <td>{caseItem.status}</td>
                      <td>{caseItem.request}</td>
                      <td>{caseItem.location}</td>
                      <td>{caseItem.date}</td>
                      <td>{caseItem.licenseNo}</td>
                      
                      <td>
                        <NavLink
                          className="btn btn-subtle"
                          to={"/update/cases/" + caseItem.id}
                        >
                          Update Data
                        </NavLink>
                        <button
                          className="btn btn-subtle"
                          onClick={() => deleteCase(caseItem.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main><ToastContainer/>
    </div>
  );
}
